import PageShell from '@/pages/shared/PageShell';
import Button from '@/components/base/Button';

export default function TemplateGanttExcel() {
  return (
    <PageShell
      title="ガントチャートExcelテンプレート無料ダウンロード｜”おもいむすび”"
      description="ガントチャート作成用のExcelテンプレートを無料ダウンロード。タスク名、開始日、終了日、進捗率、依存関係、マイルストーンを表示。プロジェクトのスケジュール管理にすぐ使えます。"
      keywords="ガントチャート テンプレート 無料,プロジェクト管理 ガントチャート エクセル,プロジェクト管理 スケジュール エクセル,ガントチャート Excel テンプレート"
      canonical="https://omoimusubi.asia/templates/gantt-chart-excel/"
      h1="ガントチャートExcelテンプレート（無料ダウンロード）"
      subtitle="プロジェクトのスケジュールを可視化するガントチャート作成用のExcelテンプレートです。ダウンロードしてすぐにお使いいただけます。"
      relatedLinks={[
        { label: 'プロジェクト管理Excelテンプレート', path: '/templates/project-management-excel/' },
        { label: 'WBSテンプレート', path: '/templates/wbs/' },
        { label: 'ガントチャートとは？作り方とツールの選び方', path: '/guides/gantt-chart/' },
        { label: 'ガントチャートツール比較', path: '/compare/gantt-chart-tools/' },
      ]}
    >
      <div className="not-prose my-8 p-8 bg-primary-50 rounded-lg border border-primary-200/70 text-center">
        <div className="w-16 h-16 mx-auto bg-accent-100 rounded-full flex items-center justify-center mb-4">
          <i className="ri-bar-chart-horizontal-line text-accent-600 text-2xl"></i>
        </div>
        <h2 className="text-xl font-bold text-foreground-900 mb-2">ガントチャートテンプレート</h2>
        <p className="text-sm text-foreground-600 mb-6">タスクの開始日・終了日を入力するだけで、自動でバーチャートが表示されます。</p>
        <a href="/templates/gantt-chart-template.xlsx" download className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 px-6 py-3 text-base transition-colors cursor-pointer"><i className="ri-download-2-line"></i>無料ダウンロード（Excel）</a><p className="text-xs text-foreground-500 mt-3">会員登録不要・無料でお使いいただけます。</p>
      </div>

      <section>
        <h2>テンプレートに含まれる項目</h2>
        <ul>
          <li><strong>タスク名</strong>：作業の名称</li>
          <li><strong>担当者</strong>：責任者</li>
          <li><strong>開始日</strong>：着手予定日</li>
          <li><strong>終了日</strong>：完了予定日</li>
          <li><strong>所要日数</strong>：開始日から終了日までの日数（自動計算）</li>
          <li><strong>進捗率</strong>：現在の進捗（0〜100%）</li>
          <li><strong>依存タスク</strong>：先行タスク名</li>
          <li><strong>マイルストーン</strong>：節目のフラグ</li>
          <li><strong>ガントチャート表示エリア</strong>：日付を横軸に、タスク期間をバーで自動表示</li>
        </ul>
      </section>

      <section>
        <h2>使い方の手順</h2>
        <ol>
          <li><strong>テンプレートをダウンロード</strong>：まずはテンプレートをダウンロードし、Excelで開きます。</li>
          <li><strong>プロジェクトの基本情報を入力</strong>：プロジェクト名、開始日、想定終了日を入力します。</li>
          <li><strong>タスクを入力</strong>：タスク名、担当者、開始日、終了日を順に入力します。ガントチャートのバーは日付に応じて自動表示されます。</li>
          <li><strong>依存関係を設定</strong>：あるタスクの前に完了すべきタスクがあれば、「依存タスク」欄にタスク名を記載します。</li>
          <li><strong>マイルストーンを設定</strong>：重要な節目となるタスクにはマイルストーンフラグを設定します。</li>
          <li><strong>進捗を更新</strong>：定期的に進捗率を更新し、プロジェクトの状況を最新に保ちます。</li>
        </ol>
      </section>

      <section>
        <h2>Excelガントチャートの限界</h2>
        <p>テンプレートを使えば簡単なガントチャートは作成できますが、以下のような制約があります。</p>
        <ul>
          <li><strong>依存関係の視覚化が困難</strong>：タスク間の矢印を手動で描画する必要があり、変更時に修正が大変です。</li>
          <li><strong>予実比較ができない</strong>：計画と実績を同一画面上で比較するのが難しく、別シートでの管理が必要です。</li>
          <li><strong>自動更新されない</strong>：日報などからの進捗反映はすべて手動です。</li>
          <li><strong>多人数での同時編集に不向き</strong>：ファイル競合やバージョン管理の問題が発生しやすくなります。</li>
        </ul>
        <p>プロジェクトの規模が大きくなったら、AIガントチャートを搭載した”おもいむすび”の無料トライアルをお試しください。AIがタスクを自動でスケジュールに展開し、日報から進捗を自動更新します。</p>
      </section>
    </PageShell>
  );
}